<template>
  <div class="switch-i18n">
    <div class="wrapper">
      <!-- 语言内容 -->
      <div class="content-wrapper" @click.stop="hiddenOptions(false)">
        <div class="text">{{ getLanguageTip() }}</div>
        <div class="arrow">
          <img src="@/assets/images/down-arrow.png" alt="arrow">
        </div>
      </div>

      <!-- 语言切换弹窗 -->
      <div class="options-wrapper" :class="{ 'options-hidden': isHiddenOptions }">
        <template v-for="(value, index) in locales" :key="value">
          <div class="option" @click.stop="hiddenOptions(true, index)">{{ localeTips[index] }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'

let { locale } = useI18n()
const locales = ['en', 'zh', 'zh-TW']
const localeTips = ['English', '简体中文', '繁體中文']
const isHiddenOptions = ref(true)

// 切换语言选项
function hiddenOptions(flag, index = -1) {
  isHiddenOptions.value = flag
  if (flag && index !== -1) {
    locale.value = locales[index]
  }
}

// 获取语言提示
function getLanguageTip() {
  const code = locale.value
  if (code === 'en') {
    return 'English'
  } else if (code === 'zh' || code === 'zh-CN') {
    return '简体中文'
  } else if (code === 'zh-HK' || code === 'zh-TW') {
    return '繁體中文'
  } else {
    return 'English'
  }
}

defineExpose({
  hiddenOptions,
})
</script>

<style scoped lang="less">
.switch-i18n {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 8px;
  font-size: 14px;
  background-color: #fff;

  @media (prefers-color-scheme: dark) {
    background-color: #000;
  }
  
  .wrapper {
    position: relative;
    padding: 4px 0;
    color: #000;

    @media (prefers-color-scheme: dark) {
      color: #fff;
    }

    .content-wrapper {
      display: flex;
      align-items: center;
      justify-content: end;
      cursor: pointer;

      .text {
        margin-right: 4px;
      }

      .arrow {
        width: 12px;
        height: 12px;

        img {
          width: 12px;
          margin-top: 3px;

          @media (prefers-color-scheme: dark) {
            filter: brightness(0) invert(1);
          }
        }
      }
    }

    .options-wrapper {
      position: absolute;
      right: 0;
      top: 100%;
      padding: 4px 8px;
      margin-top: 4px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      background-color: #fff;

      @media (prefers-color-scheme: dark) {
        background-color: #1a1a1a;
      }

      overflow: hidden;
      transition-duration: .3s;

      .option {
        padding: 4px;
        cursor: pointer;
      }

      &.options-hidden {
        height: 0;
        padding: 0;
      }
    }
  }
}
</style>
